class SeparateConfig {
    private loadPresenter = true;

    public setLoadPresenter(value: boolean) {
        this.loadPresenter = value;
    }

    public isLoadPresenter() {
        return this.loadPresenter;
    }
}

const config = new SeparateConfig();

/**
 * 设置是否使用SSR渲染，是setLoadPresenter的一个别名
 * @param value true表示不会去加载presenter
 */
export function useSSR(value: boolean) {
    config.setLoadPresenter(!value);
}

/**
 * 获取当前是否使用SSR渲染。是isLoadPresenter的一个别名
 */
export function isUseSSR(): boolean {
    return !config.isLoadPresenter();
}

/**
 * 设置是否加载presenter
 * @param value true表示不会去加载presenter
 */
export function setLoadPresenter(value: boolean) {
    config.setLoadPresenter(value);
}

/**
 * 获取当前是否加载presenter
 */
export function isLoadPresenter(): boolean {
    return config.isLoadPresenter();
}

export const testTable = {
    config,
};
